import { render } from "./InvoiceOptionsPage.vue?vue&type=template&id=4c6a8dc1&ts=true"
import script from "./InvoiceOptionsPage.vue?vue&type=script&lang=ts"
export * from "./InvoiceOptionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__